import { shopPrefix } from '../../config';
import { BucketEntry, EntryPageItemOut, EntryPageOut, QuicklinkOut } from '../../store/api';
import { AgeCategory } from '../../../models/AgeCategory';
import { ProductMetaData } from '../../../models/Product';
import { LoanFormat } from '../../../models/LoanFormat';
import { EntryPageType } from '../../../models/EntryPage';
import { mapProductOutToProductMetaData, mapProductOutToProductMetaDataArray } from '../ProductOutMappings';
import { normalizeAllLanguagesUrlKey } from '../../shop/language/constants';
import { http } from '../axios';

const FETCH_ENTRY_PAGE_URL = `${shopPrefix}/v1/entrypage`;

export type FetchEntryPageResponse = {
    readonly entryPageItems: ReadonlyArray<EntryPageItemOut>;
    readonly id: string;
    readonly sidebar: {
        readonly available: boolean;
        readonly quicklinks: ReadonlyArray<QuicklinkOut>;
        readonly titleOfMonth: ProductMetaData;
        readonly topEaudiobooks: ReadonlyArray<ProductMetaData>;
        readonly topEbooks: ReadonlyArray<ProductMetaData>;
        readonly topEpress: ReadonlyArray<ProductMetaData>;
        readonly languages: ReadonlyArray<BucketEntry>;
    };
};
export type FetchEntryPageOpts = {
    readonly loanFormat?: LoanFormat;
    readonly ageCategory?: AgeCategory;
    readonly shopLanguage?: string;
};

export const fetchEntryPage = (
    pageType: EntryPageType,
    { loanFormat, ageCategory, shopLanguage }: FetchEntryPageOpts = {}
): Promise<FetchEntryPageResponse> => {
    return http
        .get<EntryPageOut>(FETCH_ENTRY_PAGE_URL, {
            params: {
                pageType,
                ageCategory,
                loanFormat: loanFormat ? loanFormat.toUpperCase() : undefined,
                shopLanguage
            }
        })
        .then(response => mapEntryPage(response.data));
};

const mapEntryPage = (entryPage: EntryPageOut): FetchEntryPageResponse => {
    return {
        id: entryPage.id!,
        entryPageItems: entryPage.entryPageItems ?? [],
        sidebar: {
            available: !!entryPage.sidebar,
            quicklinks: entryPage.sidebar?.quicklinks ?? [],
            titleOfMonth: mapProductOutToProductMetaData(entryPage.sidebar?.titleOfMonth),
            topEaudiobooks: mapProductOutToProductMetaDataArray(entryPage.sidebar?.topEaudiobooks),
            topEbooks: mapProductOutToProductMetaDataArray(entryPage.sidebar?.topEbooks),
            topEpress: mapProductOutToProductMetaDataArray(entryPage.sidebar?.topEpress),
            languages: (entryPage.sidebar?.languages ?? []).map(it => ({
                ...it,
                key: normalizeAllLanguagesUrlKey(it.key)
            }))
        }
    };
};
